export default [
  {
    name: 'root',
    label: 'Wrapper',
    selector: '&'
  },
  {
    name: 'grid',
    label: 'Grid',
    selector: '& .testimonial-grid'
  },
  {
    name: 'gridItem',
    label: 'Grid Item',
    selector: '& .testimonial-grid-item'
  },
  {
    name: 'title',
    label: 'Title',
    selector: '& .title'
  },
  {
    name: 'title',
    label: 'Description',
    selector: '& .description'
  },
  {
    name: 'name',
    label: 'Author Name',
    selector: '& .name'
  },
  {
    name: 'position',
    label: 'Author Position',
    selector: '& .position'
  }
]